import React from 'react';
import CountryFlag from '../common/CountryFlag';

/**
 * Render a team's region as a real flag image (ISO-2 code) or a short text chip
 * for a free-form region name. Thin wrapper over :component:`CountryFlag` kept
 * for the existing league call sites; returns null when unset.
 *
 * @param {object} props - Component props.
 * @param {string} props.region - The team's region/country label.
 * @param {string} [props.className] - Extra class appended to the badge.
 * @param {('sm'|'md'|'lg')} [props.size] - Flag size; inferred larger for
 *   header/profile placements when not given.
 */
export default function RegionBadge({ region, className = '', size }) {
  if (!region) return null;
  const resolved = size
    || (className.includes('-lg') || className.includes('profile-flag') ? 'lg' : 'md');
  return <CountryFlag code={region} size={resolved} className={className} />;
}
